import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { style: {"white-space":"nowrap"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_btn_warning = _resolveComponent("v-btn-warning")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_text_field_filled = _resolveComponent("v-text-field-filled")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_btn_trash = _resolveComponent("v-btn-trash")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_btn_prev = _resolveComponent("v-btn-prev")!
  const _component_v_btn_next = _resolveComponent("v-btn-next")!
  const _component_v_data_table_server = _resolveComponent("v-data-table-server")!
  const _component_v_container = _resolveComponent("v-container")!
  const _component_GroupKeyAnalysis = _resolveComponent("GroupKeyAnalysis")!
  const _component_MergeGroupKeys = _resolveComponent("MergeGroupKeys")!
  const _component_oss_dialog = _resolveComponent("oss-dialog")!

  return (_ctx.companies)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (!_ctx.displayAnalysis)
          ? (_openBlock(), _createBlock(_component_v_container, {
              key: 0,
              "grid-list-md": "",
              fluid: "",
              style: {"min-width":"1200px"}
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_row, {
                  "no-gutters": "",
                  class: "pb-4"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_col, {
                      cols: "2",
                      class: "d-flex align-center"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_btn_warning, {
                          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.displayAnalysis = true)),
                          size: "small"
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_col, {
                      cols: "8",
                      class: "d-flex align-center"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_text_field_filled, {
                          modelValue: _ctx.filter.search,
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.filter.search) = $event)),
                          label: _ctx.searchLabel,
                          "append-inner-icon": "$search",
                          "data-cy": "companiesTable-search",
                          density: "compact",
                          "onClick:clear": _cache[2] || (_cache[2] = ($event: any) => (_ctx.filter.search = '')),
                          clearable: ""
                        }, null, 8, ["modelValue", "label"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_col, {
                      cols: "2",
                      class: "d-flex justify-end align-center"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_btn, {
                          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.dialog = true)),
                          disabled: _ctx.btnDisabled,
                          size: "small"
                        }, {
                          default: _withCtx(() => _cache[12] || (_cache[12] = [
                            _createTextVNode(" Regrouper ")
                          ])),
                          _: 1
                        }, 8, ["disabled"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_data_table_server, {
                  modelValue: _ctx.selectedRows,
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.selectedRows) = $event)),
                  items: _ctx.selectData,
                  headers: _ctx.dataHeader,
                  page: _ctx.filter.page,
                  "sort-by": _ctx.filter.sortBy,
                  "items-per-page": _ctx.filter.rowsPerPage,
                  "items-length": _ctx.filter.totalItems,
                  class: "table",
                  height: '79vh',
                  "multi-sort": false,
                  "fixed-header": "",
                  "hide-default-footer": "",
                  "show-select": true
                }, {
                  "item.name": _withCtx(({ item }) => [
                    _createTextVNode(_toDisplayString(_ctx.getFullCompanyName(item)), 1)
                  ]),
                  "item.siret": _withCtx(({ value }) => [
                    _createTextVNode(_toDisplayString(value), 1)
                  ]),
                  "item.siren": _withCtx(({ value }) => [
                    _createTextVNode(_toDisplayString(value), 1)
                  ]),
                  "item.parentCompany": _withCtx(({ item }) => [
                    _createTextVNode(_toDisplayString(_ctx.getParentCompanyName(item.parentCompany)), 1)
                  ]),
                  "item.activities": _withCtx(({ item }) => [
                    _createTextVNode(_toDisplayString(_ctx.getActivityName(item.activities)), 1)
                  ]),
                  "item.groupKey": _withCtx(({ item }) => [
                    (item.groupKey)
                      ? (_openBlock(), _createBlock(_component_v_row, {
                          key: 0,
                          "no-gutters": ""
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_col, { cols: "9" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_btn, {
                                  rounded: "",
                                  elevation: "0",
                                  onClick: ($event: any) => (_ctx.searchGK(item)),
                                  size: "small",
                                  color: "filled"
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(item.groupKey), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["onClick"])
                              ]),
                              _: 2
                            }, 1024),
                            _createVNode(_component_v_col, { cols: "3" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_btn_trash, {
                                  onClick: ($event: any) => (_ctx.deleteGroupKey(item)),
                                  size: "small"
                                }, null, 8, ["onClick"])
                              ]),
                              _: 2
                            }, 1024)
                          ]),
                          _: 2
                        }, 1024))
                      : _createCommentVNode("", true)
                  ]),
                  top: _withCtx(() => [
                    _createVNode(_component_v_row, {
                      "no-gutters": "",
                      class: "d-flex justify-end border-b"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_spacer),
                        _createVNode(_component_v_col, {
                          cols: "3",
                          class: "d-flex justify-end align-center"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_select, {
                              modelValue: _ctx.filter.rowsPerPage,
                              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.filter.rowsPerPage) = $event)),
                              items: [5, 10, 25],
                              "hide-details": "",
                              class: "top-pagination",
                              style: {"min-width":"170px"},
                              prefix: "Lignes par page"
                            }, null, 8, ["modelValue"]),
                            _createElementVNode("span", _hoisted_2, _toDisplayString((_ctx.filter.page - 1) * _ctx.filter.rowsPerPage + 1) + " - " + _toDisplayString((_ctx.filter.page - 1) * _ctx.filter.rowsPerPage + _ctx.filter.rowsPerPage) + " de " + _toDisplayString(_ctx.filter.totalItems), 1),
                            _createVNode(_component_v_btn_prev, {
                              onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.filter.page--)),
                              disabled: _ctx.filter.page === 1,
                              size: "small"
                            }, null, 8, ["disabled"]),
                            _createVNode(_component_v_btn_next, {
                              onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.filter.page++)),
                              disabled: _ctx.nextPageDisabled,
                              size: "small"
                            }, null, 8, ["disabled"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  "header.groupKey": _withCtx(({ column }) => [
                    _createVNode(_component_v_row, { "no-gutters": "" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_col, { class: "d-flex justify-center align-center" }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(column.title) + " ", 1),
                            _createVNode(_component_v_select, {
                              modelValue: _ctx.filter.groupKeySearch,
                              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.filter.groupKeySearch) = $event)),
                              items: _ctx.allGroupKeys,
                              placeholder: "Rechercher une clef",
                              clearable: "",
                              class: "small-select-font",
                              density: "compact"
                            }, null, 8, ["modelValue", "items"])
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _: 1
                }, 8, ["modelValue", "items", "headers", "page", "sort-by", "items-per-page", "items-length"])
              ]),
              _: 1
            }))
          : (_openBlock(), _createBlock(_component_GroupKeyAnalysis, {
              key: 1,
              onAnalysisDone: _cache[9] || (_cache[9] = ($event: any) => (_ctx.closeAnalyze())),
              onGroupDone: _ctx.dataAnalysis
            }, null, 8, ["onGroupDone"])),
        _createVNode(_component_oss_dialog, {
          modelValue: _ctx.dialog,
          "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.dialog) = $event)),
          actions: _ctx.actions,
          title: "",
          "max-width": "66vw"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_MergeGroupKeys, {
              companiesId: _ctx.selectedRows,
              actions: _ctx.actions,
              ref: "mergeGroupKeyIndex",
              onMergeDone: _cache[10] || (_cache[10] = ($event: any) => (_ctx.closeDialog()))
            }, null, 8, ["companiesId", "actions"])
          ]),
          _: 1
        }, 8, ["modelValue", "actions"])
      ]))
    : _createCommentVNode("", true)
}